import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "LICEcap - best screen capture tool I've ever used",
  "description": "",
  "published": "2013-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/licecap-best-screen-capture-tool-ive-ever-used/swizec/6417"],
  "categories": "Animation, Graphics Interchange Format, Screencast, Uncategorized",
  "hero": "./img/images-3936.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/c00115ca0ef24da8a695affab2fd9d26/images-3935.gif",
        "alt": null
      }}></img></p>
    <p>{`Typing under pressure from a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Screencast",
        "title": "Screencast"
      }}>{`screen recorder`}</a>{` is really hard. Kudos to everyone who makes educational screencasts to help people learn programming.`}</p>
    <p>{`But `}<a parentName="p" {...{
        "href": "http://www.cockos.com/licecap/"
      }}>{`LICEcap`}</a>{` really is the best screen recorder I've ever used. Definitely the simplest. The best example of doing one thing and doing it well.`}</p>
    <p>{`Turn your screen into a GIF.`}</p>
    <p>{`That's it. That's all you can do with LICEcap. It won't help you create the next `}<a parentName="p" {...{
        "href": "http://railscasts.com/",
        "title": "Railscasts"
      }}>{`Railscasts`}</a>{` or `}<a parentName="p" {...{
        "href": "http://https://www.coursera.org/",
        "title": "Coursera"
      }}>{`Coursera`}</a>{`, but if you want to make something move in your slides when giving a talk, you need a GIF. If you want to simply embed some moving parts into your blogpost - GIF.`}</p>
    <p>{`For example, I used LICEcap to make those gifs of Super Mario playing with himself for Week 2 of the 52papers challenge.`}</p>
    <p><img parentName="p" {...{
        "src": "/0fad961aa5bba84ec35bc57903778cc6/images-3933.gif",
        "alt": "Naive Super Mario",
        "title": "Naive Super Mario"
      }}></img></p>
    <p>{`It also came in handy for the talk I gave about d3.js a few weeks ago where I wanted to show people animated graphs, but didn't want to keep jumping in and out of the presentation and fumbling around with a thousand windows. That never goes well.`}</p>
    <p>{`My favourite part of using LICEcap is that it's simple. You open the app, put it over the content you want to record, click a button and away you go. The app will automatically save an animated GIF file when you're done recording.`}</p>
    <p>{`No fumbling around with selecting regions and hidden control windows. No worrying about sound or converting the recorded video into GIF form.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/9d19b6ec723b8b03281042ad52c4c851/497e9/images-3936.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.47085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'262\\'%20viewBox=\\'0%200%20400%20262\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M121%201l4%202-1%201a4284%204284%200%2000185%200c-5%200-7-1-7-3l-8%201c-11%202-19%202-22%201l-1-2a912%20912%200%2000-129%202c0-2-6-3-14-3-9%200-9%200-7%201m-6%2017l5%202%2016%2010c2%200%202%200%201%201v1l1%202v1l3%201h7l5%201-2%201c-1%200-2%201-2%205%200%202%200%203%203%203l3%202h2l1%201h2l1%201h2l1%201%209%203h2l2%201h1l2%201%201-1c0-2%200-2%201-1h3c5-3%2017%201%2024%207l6%203c3%200%2012%204%2019%208l9%203%206%201c4%203%204-2%201-5-1-2-1-2%202-2%204%200%206%202%207%207%200%204%202%205%206%201%202-1%202-1%207%201%204%202%207%206%205%206l3%202c3%202%203%202%204%201h4c3%202%204%204%201%204-4%200-4%202-1%202%205%202%208%201%2010-1%202-3%203-3%208-3%203%200%205%200%204%201l-2%202-1%201-1%201%205%201c4-1%204%200%204%202s0%203-1%202l-4-1-4-1-3-1c-1%200-1%201%201%202l3%203%205%201%205-1%202-2%202-1h4l3%204%202%202h3l18%201c4%202%209%204%209%202v-1l1%201c0%202%203%204%205%204v-1c0-2%201-2%208-1h4l-6-5-2-1v-1c4%201%207%200%207-1-1-1%200-2%201-2%203%200-1-2-7-3l-8-3h-3l-2-1h-3l-2%201v-7l-3-1-5-3h18l3-2c4%200%202-3-2-4-12-3-23-10-16-10l3-3%203-4%201-2c-1-1%202-2%206-2%203%200%203%200%203-3l1-4-4-2-7-3c-2-2-6-12-5-14l-1-2-1-2-3-3-3-2-3-1a4223%204223%200%2000-224-1m82%202l7%207%201%201c0%202%207%204%2010%203l6-2c3%200%204%200%203-1h-3l-2-1%201-1v-1h-2l-1-1-1-1c-2%200-2%200-2-2%200-1%201-2%206-2%2013%200%207-1-8-1-13%200-15%200-15%202m86%204c-5%201-6%202-3%204%202%202%203%205%201%206s-3%206-1%207l18%207c3%200%203%200%202-2-1-4-2-5-5-5l-2-1-3-1c-3%200-6-3-4-3h7c7%200%208-1%208-5%201-6-8-9-18-7M56%2034c-2%202-2%202-1%203%202%200%203%205%201%207-1%201-1%201%202%202s3%202%203%204l-1%203a891%20891%200%2001-43-12l-1%20103v103h371v-9l-1-40v-31l-5-2c-9-4-24-7-22-5%201%202-3%200-13-4a505%20505%200%2000-63-27l-3-1c-2%200-2-2-1-3%202-2%201-5-1-5-1%200-3%200-4%202-3%202-3%202-6%201a239%20239%200%2000-29-9l-24-9c-6-2-10-2-4%200%203%201%203%201%202%202h-5c-6-2-8-5-5-5l-10-4v2c-3%200-7-3-5-3h-1c-2%200-3%200-2-1l-14-5A1241%201241%200%200046%2055l-8-3h6l8%202%2010%203a1147%201147%200%200066%2019l20%205-17-6c-21-6-23-7-23-8l-1-1c-1%201-7-1-13-3-10-3-10-3-8-5%204-1%204-4%203-7l-2-4c0-4-1-6-2-6l-1-1c0-2-1-2-3-2-3%200-13-4-10-4l-1-1c-4-2-12-1-14%201M0%20149v113h79a762%20762%200%200082-1l120%201h120V149l-1-70a251%20251%200%2001-1%2046l1%2020v20l-5-2c-4-1-5-2-5-5%200-2-1-1-1%203s0%206%201%204c0-1%201-2%205%200%205%201%205%201%205%205s0%204-8%200l-3-1v88H13V40l-5-1-7-2-1%20112m244-97c0%202%209%209%2013%209%205%200%206%200%204-2v-3c1-1%200-2-3-3-5-2-14-2-14-1m64%2024c-2%200-1%202%201%202l3%203c1%203%205%205%209%205%202-1%203%200%203%201s-3%203-4%202l-2%201c-1%201%203%204%207%206l3%202%206%201%207-1-1-1v-5l-5-4c-6-6-7-6-13-6-3%200-4%200-6-3-3-3-6-4-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9d19b6ec723b8b03281042ad52c4c851/ca0a1/images-3936.webp 223w", "/static/9d19b6ec723b8b03281042ad52c4c851/75680/images-3936.webp 445w", "/static/9d19b6ec723b8b03281042ad52c4c851/8d1ba/images-3936.webp 890w", "/static/9d19b6ec723b8b03281042ad52c4c851/3838e/images-3936.webp 1335w", "/static/9d19b6ec723b8b03281042ad52c4c851/e11e5/images-3936.webp 1780w", "/static/9d19b6ec723b8b03281042ad52c4c851/beba9/images-3936.webp 2064w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9d19b6ec723b8b03281042ad52c4c851/e92b6/images-3936.png 223w", "/static/9d19b6ec723b8b03281042ad52c4c851/e66bf/images-3936.png 445w", "/static/9d19b6ec723b8b03281042ad52c4c851/4ef49/images-3936.png 890w", "/static/9d19b6ec723b8b03281042ad52c4c851/4e814/images-3936.png 1335w", "/static/9d19b6ec723b8b03281042ad52c4c851/701e9/images-3936.png 1780w", "/static/9d19b6ec723b8b03281042ad52c4c851/497e9/images-3936.png 2064w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9d19b6ec723b8b03281042ad52c4c851/4ef49/images-3936.png",
                "alt": "LICEcap in use",
                "title": "LICEcap in use",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`LICEcap in use`}</figcaption>{`
  `}</figure></p>
    <p>{`Sure, it sucks that video on the web and in presentation is still not a very well solved problem and takes more fumbling around than necessary. But with today's broadband speeds, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Graphics_Interchange_Format",
        "title": "Graphics Interchange Format"
      }}>{`GIFs`}</a>{` have become perfectly viable.`}</p>
    <p>{`Love it.`}</p>
    <p><img parentName="p" {...{
        "src": "/aa010f892bae0c9aa157a2e5e03ba23c/images-3937.gif",
        "alt": "My surfing wipeout",
        "title": "My surfing wipeout"
      }}></img></p>
    <p>{`Although you might still want to use `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Adobe_Photoshop",
        "title": "Adobe Photoshop"
      }}>{`Photoshop`}</a>{` to convert real videos into good GIFs ...`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=baddadd7-0053-432f-b323-9c90a87f3b65",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      